/** Basic email pattern */
const EMAIL_PATTERN = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/;

/** US-style phone numbers and similar digit groupings */
const PHONE_PATTERN = /(?:\+?\d{1,3}[\s.-]?)?(?:\(?\d{3}\)?[\s.-]?)\d{3}[\s.-]?\d{4}/;

/** SSN-like ###-##-#### */
const SSN_PATTERN = /\b\d{3}-\d{2}-\d{4}\b/;

/** Credit-card-like runs (13–19 digits with optional separators) */
const CARD_LIKE_PATTERN = /\b(?:\d[\s-]?){13,19}\b/;

/** Long digit runs that may contain sensitive identifiers */
const LONG_DIGIT_RUN_PATTERN = /\b\d{10,}\b/;

/** URLs with scheme or www prefix */
const URL_PATTERN = /\b(?:https?:\/\/|www\.)[^\s]+/i;

/** Social-style @handles (2+ word chars after @) */
const HANDLE_PATTERN = /@[\w.]{2,}/;

const HIGH_RISK_PATTERNS = [
  EMAIL_PATTERN,
  PHONE_PATTERN,
  SSN_PATTERN,
  CARD_LIKE_PATTERN,
  LONG_DIGIT_RUN_PATTERN,
  URL_PATTERN,
  HANDLE_PATTERN,
] as const;

/**
 * Returns true when a search query matches any high-risk PII pattern
 * (email, phone, SSN, card-like or long digit runs, URLs, @handles).
 * Used as a hard gate: matching queries suppress search analytics events
 * entirely rather than emitting redacted text.
 */
export function containsSearchQueryPii(trimmedQuery: string): boolean {
  if (!trimmedQuery) return false;

  return HIGH_RISK_PATTERNS.some((pattern) => pattern.test(trimmedQuery));
}
